import {createAsyncThunk} from "@reduxjs/toolkit"
import {setMessage, setStatus} from "./appReducer"
import {CommonResponse} from "../api/API"

type ApiResponse<T> = Promise<CommonResponse<T>>

export function asyncCreator<TApiFunc extends (params?: any) => ApiResponse<any>>(prefix: string, apiFunc: TApiFunc, reducerMethod?: any, message?: string)
{
    type TParams = Parameters<TApiFunc>[0]
    type TData = Awaited<ReturnType<TApiFunc>> extends { data: infer R } ? R : never

    return createAsyncThunk(
        prefix,
        async (params: TParams, {dispatch}) =>
        {
            if (!params?.withoutLoadingIndicator)
            {
                dispatch(setStatus("loading"))
            }
            try
            {
                delete params?.withoutLoadingIndicator
                const res = await apiFunc(params)
                if (res.status === 0)
                {
                    if (reducerMethod) dispatch(reducerMethod(res.data))
                    if (message) dispatch(setMessage({type: "success", message}))
                    dispatch(setStatus("success"))
                }
                else
                {
                    dispatch(setMessage({type: "error", message: res.message}))
                    dispatch(setStatus("reject"))
                }
                return res as TData
            } catch (e: any)
            {
                catchError(e, dispatch)
            }
        },
    )
}

export const catchError = (e: any, dispatch: any) =>
{
    console.log(JSON.stringify(e, null, 2))
    console.log(JSON.stringify(e.response, null, 2))
    if (e.message === "canceled") return
    let message = "Что-то пошло не так..."
    if (typeof e.response?.data === "string") message = e.response.data
    else if (e.response?.data?.message) message = e.response.data.message
    else if (e.response?.data?.title) message = e.response.data.title
    else if (e.message) message = e.message

    dispatch(setStatus("failed"))

    dispatch(setMessage({
        type: "error",
        message: message,
    }))

    return message
}
